import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import QuestionView from "ToddleLibrary/routes/QuestionView";
export default store => {
  return {
    path: "questions",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [QuestionView(store)],
  };
};
